
/**
 * @Description 配合审批流的可读配置来显示动态组件是否处于禁用状态
 */
import {
  useMemo
} from 'react';

/**
 * TODO(2026-1029迭代/机会点表单字段必填/可见/可写，文档：https://confluence.lanhanba.com/pages/viewpage.action?pageId=172107370)：
 * 按发起节点表单权限区分“可写”和“仅可见”，并限制规则只作用于 Locxx 拓店任务模板。
 */

export function useAccessIsDisabled({
  taskEntry,
  supportDirectApproval,
  propertyItem,
  /** 是否传统的点位评估编辑页（不包含一鸣等租户走机会点点位评估审批流的场景），是的话item的显示、禁用，参照的是机会点拓店模板、非流程设置 */
  isTraditionEvaluation,
  /** 是否机会点表单，加盟商、踩点记录时false */
  isChancepoint = true,
}
) {
  return useMemo(() => {
    const { access } = propertyItem;
    // Locxx 拓店任务模板下，字段禁用状态由 access 统一控制
    // 不与 isTraditionEvaluation 耦合：该标志在拓店任务编辑场景下由 release 逻辑置 true，会让本分支失效
    if (isChancepoint && taskEntry === true) {
      // access 1：仅可见  2：可写 3:不可见 null:历史数据的不可见
      if (access === 1) return true;
      if (access !== null && access !== undefined) return false;
      // access=null/undefined 沿用原审批流和 restriction.disable 判断。
    }
    // 支持提交审批时（即走配置的审批流时）；点位评估时，虽然支持审批，但是读取的是拓店模板设置，不参照流程设置
    if (isChancepoint && supportDirectApproval === 1 && !isTraditionEvaluation) {
      // access 1：仅可见  2：可写 3:不可见 null:历史数据的不可见
      return access === 1;
    }

    const restriction = propertyItem.restriction ? JSON.parse(propertyItem.restriction) : {};
    return !!restriction?.disable;
  }, [propertyItem, taskEntry, supportDirectApproval, isTraditionEvaluation, isChancepoint]);
}

